module.exports = __webpack_public_path__ + "static/11-837dc5819ee0431a89f8146330ea055f.jpg";